/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Sitting_OutInputs */



/**
* | output |
* | --- |
* | "You sit out this round. That's normal: sit-outs rotate so everyone plays the same number of rounds. You'll play in a later round." |
*
* @param {Player_Sitting_OutInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const player_sitting_out = /** @type {((inputs?: Player_Sitting_OutInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Sitting_OutInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous ne jouez pas cette ronde. C'est normal : le repos tourne pour que tout le monde joue autant de rondes. Vous jouerez à une prochaine ronde.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descansa esta ronda. Es normal: el descanso rota para que todos jueguen el mismo número de rondas. Jugará en una ronda posterior.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Você fica de fora nesta rodada. É normal: as folgas se revezam para que todos joguem o mesmo número de rodadas. Você jogará em uma rodada seguinte.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riposi in questo round. È normale: il riposo ruota perché tutti giochino lo stesso numero di round. Giocherai in un round successivo.")
	return /** @type {LocalizedString} */ ("You sit out this round. That's normal: sit-outs rotate so everyone plays the same number of rounds. You'll play in a later round.")
});